import { type FC } from 'react';
import { getBillboardAdData } from 'dibs-google-ad-manager/exports/adHelpers.ts';
import { BillboardBannerAd } from 'dibs-google-ad-manager/exports/BillboardBannerAd.ts';
import { type AdBillboardPlacement } from 'dibs-google-ad-manager/exports/types.ts';

import dibsCss from 'dibs-css';
import classnames from 'classnames';
import styles from './InteriorBillboardAd.scss';

type Props = {
    placement: AdBillboardPlacement;
    isDesktop: boolean | undefined;
    isLazyLoad?: boolean;
};

export const InteriorBillboardAd: FC<Props> = ({ placement, isLazyLoad, isDesktop }) => {
    // Tablet should get mobile ad
    const adWidth = isDesktop ? 'desktop' : 'mobile';
    const billboardAdData = getBillboardAdData(placement)?.[adWidth];

    if (!billboardAdData) {
        return null;
    }

    return (
        <div className={classnames(styles.wrapper, dibsCss.bgMoonstone)}>
            <BillboardBannerAd
                {...billboardAdData}
                lazyLoad={isLazyLoad}
                className={dibsCss.pyXsmall}
            />
        </div>
    );
};
